import React from 'react';
import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import { useStateCode } from '@hooks/index';


const StyledContainer = styled.div`
    margin-bottom: 30px;
`;

const NoEnrollmentMessage = () => {

    const { isNoEnrollmentBorder } = useStateCode();
    const borderClass = isNoEnrollmentBorder ? 'noEnrollment-without-shadow' : 'noEnrollment-with-shadow';

    return (
        <StyledContainer className={`noEnrollment ${borderClass}`}>
            <p >
                <FormattedMessage id="indportal.portalhome.noenrollmentsfound" />
            </p>
        </StyledContainer>
    );
};

export default NoEnrollmentMessage;